import { render, staticRenderFns } from "./ProductPageScreenBracelet.vue?vue&type=template&id=7bb7217c&scoped=true&"
import script from "./ProductPageScreenBracelet.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenBracelet.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenBracelet.vue?vue&type=style&index=0&id=7bb7217c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb7217c",
  null
  
)

export default component.exports